import Tooltip, { TooltipProps } from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import React from "react";

const HtmlTip = ({ className, ...props }: TooltipProps) => {
  const { title } = props;

  return (
    <Tooltip
      {...props}
      title={
        <React.Fragment>
          <Typography
            color="inherit"
            dangerouslySetInnerHTML={{ __html: title }}
          ></Typography>
        </React.Fragment>
      }
      classes={{ popper: className }}
      placement="top"
    />
  );
};

export default HtmlTip;
